module.exports = __webpack_public_path__ + "h5/img/home1.18fe6e27.png";